import { Prefectur } from '@/domain/Prefectur'
import axios from 'axios'

/**
 * 都道府県サービス
 */
export default class PrefecturesService {
    /** インスタンス */
    private static _instance: PrefecturesService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new PrefecturesService();
        }
        return this._instance;
    }

    /**
     * 都道府県一覧を検索
     */
    public async findAll(): Promise<Prefectur[]> {
        return await axios.get("/api/prefectures")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Prefectur[]).map(x => new Prefectur({ ...x }))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
